<template>
    <MyForm :title="'Seismic'">
        <template v-slot:fields>
              <div class = debug>
        <p>lat = {{ lat }}</p>
        <p>lon = {{ lon }}</p>
        <p>URL = {{ URL }}</p>
        <p>graphqlQuery = {{ graphqlQuery }}</p>
    </div>
            <div v-if="loading"> Loading Seismic Data...</div>

            <div v-if="error"> Error: {{ error }}</div>

            <div v-if="seismicData">
                <p>Seismic Data = {{ seismicData }}</p>

            </div>
        </template>

        <template v-slot:buttons>
            <FormBtn :name="'Fetch Seismic Data (Not yet implemented)'" @clicked="getSeismicData" disabled=true></FormBtn>
   
        </template>

    </MyForm>
 
    
    
    <!--
    <div data-test="fetched"> response : {{response}}</div>
    <div data-test="status"> response status: {{status}}</div>
    <div>request: {{myRequest}}</div>
    <div>error: {{ error }}</div>-->
</template>


<script setup lang="ts">
/**
 * NOTE: USING AXIOS IS CAUSING CORS ISSUES WITH THE SERVER, USING BASIC RESPONSE OBJECT SEEMS TO BE NO DIFFERENT..
 * OPTIONS RESPONSE FROM SERVER STATES MULTIPLE ALLOW-ORIGIN HEADERS NOT ALLOWED
 *
 */
import { computed } from 'vue';
import axios from 'axios';
import { ref, onMounted } from 'vue';
import FormBtn from './form/Form-btn.vue';
import MyForm from './form/My-form.vue';

const URL = "https://www.earthquakescanada.nrcan.gc.ca/api/canshm/graphql";
const loading = ref(false);
const error = ref(null);
const seismicData = ref(null);


//working : curl -i -X POST https://www.earthquakescanada.nrcan.gc.ca/api/canshm/graphql --header "Content-Type: application/json" --data  '{"query" : "{ NBC2020(latitude: 48.42, longitude: -123.479){ XE: siteDesignationsXs(siteClass: E, poe50: [2.0]){ sa0p2 sa0p5 }}}"}'
//const URL_TEST = 'https://www.earthquakescanada.nrcan.gc.ca/api/canshm/graphql?query={NBC2025(latitude:48.42,longitude:-123.479){XE: siteDesignationsXs(siteClass: E, poe50: [2.0]){sa0p2 sa0p5}}}';


const props = defineProps({
    lat : { type: Number, required : true },
    lon : { type: Number, required : true}
})

//make a non-reactive copy of gps
const gps = computed(()=>{
    return {
        'lat' : JSON.parse(JSON.stringify(props.lat)),
        'lon' : JSON.parse(JSON.stringify(props.lon))
    }
})

const graphqlQuery =  computed(()=>{
  return  {"query" : `"{NBC2025(latitude: ${gps.value.lat}, longitude: ${gps.value.lon}){
    XE: siteDesignationsXs(siteClass: E, poe50: [2.0]){
      sa0p2
      sa0p5
    }
  }"`}
})

/*const graphqlQuery = {
    "operationName": "fetchAuthor",
    "query": `query fetchAuthor { author { id name } }`,
    "variables": {}
};*/

/**
 * 
 */
async function fetchSeismic(){
    return await axios({
        method: 'post',
       // mode: 'no-cors',
        url : URL,
        data: graphqlQuery.value,
        headers: {
        'Content-Type' : 'application/json',
        //'Access-Control-Allow-Origin' : '*'
        }
    }).catch((err)=>{
        console.error("axios error in fetchSeismic : " + err);
        //error.value = err;
        throw err;
        //return err;
        //throw error;
    })  
}

/**
 * 
 */
async function getSeismicData(){
    console.log("Seismic-fetch.getSeismicData()...");
    error.value = seismicData.value = null;
    loading.value = true;
    try{
        const data = await fetchSeismic();
        seismicData.value = data.data;
    }catch(err){
        error.value = err.toString();
    }finally{
        loading.value= false;
    }
    console.log("..seismicData = " );//+ JSON.stringify(seismicData));
}

/*const queryString = new URLSearchParams({
    query : QUERY
})*/
/*
const myRequest = new Request(URL_TEST, {
    method : "POST",
    body: 'query=' + QUERY
});
*/
//const myRequest = new Request(`${URL_TEST}?${queryString}`)
/*const myRequest = new Request(URL_TEST);
const response = ref('');
const status = ref('');*/
//const error = ref(null);

/*onMounted(async ()=>{
    //response.value = await fetchSeismic();
    //await myRequest.text().then((resp)=>{
    await fetch(myRequest).then(async (resp) =>{
        response.value = await resp.json();
        console.log("..resp = " + resp.json());
    }).catch(error=>{
        console.log("..error with fetching seismic endpoint..." + error);
        error.value = error;
    })
   // console.log(JSON.stringify(response));
   // status.value = response.value.status;   //200
})*/
    
</script>
